import { GET_BIENS, GET_SPECIFIC_BIEN, ADD_BIEN, EDIT_BIEN, EDIT_VENTE_BIEN_PRICE, DELETE_BIEN, BIENS_LOADING, CLEAR_BIENS, CLEAR_SPECIFIC_BIEN, BIEN_VENDU, UPDATE_BIEN_DOA, UPDATE_BIEN_DIVISION } from '../types';
import { IAction, IBien } from '../../types/interfaces';

const initialState = {
  biens: [],
  info: {},
  loading: false
};

interface IState {
  biens: IBien[];
  info: any;
}

export default function(state: IState = initialState, action: IAction) {
  switch (action.type) {
    case GET_BIENS:
      return {
        ...state,
        biens: action.payload,
        loading: false
      };
    case GET_SPECIFIC_BIEN:
      return {
        ...state,
        info: action.payload,
        loading: false
      };
    case BIENS_LOADING:
      return {
        ...state,
        loading: true
      };
    case CLEAR_BIENS:
      return {
        ...state,
        biens: []
      };
    case CLEAR_SPECIFIC_BIEN:
      return {
        ...state,
        info: {}
      };
    case ADD_BIEN:
      return {
        ...state,
        biens: [...state.biens, action.payload]
      };
    case EDIT_BIEN:
      return {
        ...state,
        biens: state.biens.map(e => e.id == action.payload.id ? action.payload : e)
      };
    case EDIT_VENTE_BIEN_PRICE:
      return {
        ...state,
        biens: action.payload?.bien ? state.biens.map(e => e.id == action.payload.bien.id ? action.payload.bien : e) : state.biens,
        info: (action.payload?.bien && state.info.id === action.payload.bien.id) ? action.payload.bien : state.info
      };
    case DELETE_BIEN:
      return {
        ...state,
        biens: state.biens.filter(e => e.id !== action.payload)
      };
    case BIEN_VENDU:
      return {
        ...state,
        biens: state.biens.map(e => (action.payload?.vente?.bien && e.id === action.payload.vente.bien.id) ? action.payload.vente.bien : e)
      };
    case UPDATE_BIEN_DOA:
      return {
        ...state,
        biens: state.biens.map(e => {
          const doa = action.payload?.find(t => t.bien_id === e.id)
          if(doa){
            if(e.demande_ouverture_associations?.find(t => t.id == doa.id))
              return {...e, demande_ouverture_associations: e.demande_ouverture_associations?.map(t => t.id === doa.id ? doa : t)}
            else
              return {...e, demande_ouverture_associations: [...e.demande_ouverture_associations || [], doa]}
          }
          else
            return e
        })
      };
    case UPDATE_BIEN_DIVISION:
      return {
        ...state,
        biens: state.biens.map(e => action.payload?.find(t => t.bienId === e.id) ? {...e, division: action.payload?.find(t => t.bienId === e.id)} : e)
      };
    default:
      return state;
  }
}
